Controller = App.loadClass 'core::Angular/Controller'

class exports.PicsController extends Controller
    constructor: (@scope, @transitions, @data, @modal) ->
        @scope.title = 'Pics'
        @scope.fullpage = true
        @scope.absolute_errors = true

        @scope.bigPicture = null
        @scope.displayBigPicture = @displayBigPicture
        @scope.turnOffBigPicture = @turnOffBigPicture
        @scope.launchAddPicDialog = @launchAddPicDialog

        @loadScopeData @data.getPics(), 'pics'

    displayBigPicture: (pic) =>
        @scope.bigPicture = pic

    turnOffBigPicture: () =>
        @scope.bigPicture = null

    launchAddPicDialog: () =>
        modal = @modal.open
            windowClass: 'modal-width'
            templateUrl: 'backend/admin/pics/load-layout-add-pic-dialog'
            controller: 'Funsies.Controllers.AddPicController'

        modal.result.then () =>
            @loadScopeData @data.getPics(), 'pics'
